var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pronostico-aire"},[_c('div',{staticClass:"pronostico-aire__bar"},[_c('desktop-footer',{staticClass:"pronostico-aire__bar__desktop-footer"})],1),(_vm.alerts && _vm.alerts.length > 0)?_c('alert-modal',{attrs:{"alerts":_vm.alerts}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }